/* app/js/src/components/common/evrideo-keyboard-shortcuts/evrideo-keyboard-shortcuts.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  -webkit-user-select: none !important;
  user-select: none !important;
}
.container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}
.container .vertical-separator {
  width: 1px;
  background-color: #ccc;
  margin: 0 10px;
}
.container section {
  width: 250px;
}
.container section h3 {
  text-decoration: underline;
  text-underline-offset: 10px;
  text-transform: uppercase;
}
.container section .shortcuts {
  padding-right: 10px;
  box-sizing: border-box;
  flex-basis: 150px;
}
.container section .shortcuts .shortcut {
  overflow: hidden;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}
.container section .shortcuts .shortcut .letters {
  display: flex;
  gap: 5px;
}
.container section .shortcuts .shortcut .letters .letter {
  background: rgba(0, 0, 0, 0.85);
  border-radius: 4px;
  padding: 5px 0px 5px 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  height: 30px;
  position: relative;
  overflow: hidden;
}
.container section .shortcuts .shortcut .letters span {
  color: rgb(255, 255, 255);
  text-align: center;
  font-family: "OpenSans-SemiBold", sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  text-transform: uppercase;
  position: relative;
  padding: 2px 8px;
}
.container section .shortcuts .shortcut pre {
  overflow: hidden;
  white-space: pre-wrap;
  word-wrap: break-word;
}
/*# sourceMappingURL=evrideo-keyboard-shortcuts.component.css.map */
